// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1JVeW","actions":"GroupTable_actions__2lkuO","deleteModalFooter":"GroupTable_deleteModalFooter__2BX5o"};